import React from 'react';

const Close = () => (
    <svg width='24' height='25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='m6 6.423 12.774 12.774M6 19.197 18.774 6.423'
        stroke='var(--cvna-color-blue-6)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );

export default Close;
